module.exports = __webpack_public_path__ + "static/prevent-detect-respond-mac-a7c5747080e0ac8f32a3ceb54e574dd1.webp";